import React from "react";
import {
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  NoteAdd as NoteAddIcon,
  History as HistoryIcon,
  Add as AddIcon,
  Person as PersonIcon,
  AccountTree as AssetIcon,
  DirectionsBus as VehicleIcon,
  Settings as SettingsIcon,
  DashboardOutlined as DashboardOutlinedIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Route,
  Storage,
} from "@mui/icons-material";

// Global Labels Enum - Centralized terminology management
export const GlobalLabels = {
  // Main Entity Labels
  PROJECT: {
    SINGULAR: "Project",
    PLURAL: "Projects",
    LOWER_SINGULAR: "project",
    LOWER_PLURAL: "projects",
    ALTERNATIVES: {
      CONTRACT: "Contract",
      CONTRACTS: "Contracts",
      JOB: "Job",
      JOBS: "Jobs",
      WORK: "Work",
      WORKS: "Works",
      ASSIGNMENT: "Assignment",
      ASSIGNMENTS: "Assignments",
    },
    TAG: {
      SINGULAR: "Tag",
      PLURAL: "Tags",
      LOWER_SINGULAR: "tag",
      LOWER_PLURAL: "tags",
    },
  },

  // Tab Labels
  TABS: {
    DIVISIONS: {
      LABEL: "Divisions",
      DESCRIPTION: "Project divisions and overview",
      ICON: AssetIcon,
    },
    CONTRACT: {
      LABEL: "Agreement",
      DESCRIPTION: "Project agreement and overview",
      ICON: DescriptionIcon,
    },
    SUMMARY: {
      LABEL: "Summary",
      DESCRIPTION: "Project summary and overview",
      ICON: DashboardOutlinedIcon,
    },
    ALLOCATIONS: {
      LABEL: "Allocations",
      SINGULAR: "Allocation",
      DESCRIPTION:
        "Manage all allocations (vehicles, resources, assets) for the project",
      BUTTON: {
        LABEL: "New Allocation",
        ICON: AddIcon,
      },
      ICON: AssignmentIcon,
      ACTION_LABEL: "Allocate",
      ACTION_LABEL_PAST_TENSE: "allocated",
      OPPOSITE: "Remove",
    },
    LOGS: {
      LABEL: "Daily Logs",
      DESCRIPTION: "Project logs and activity",
      ICON: HistoryIcon,
    },
    INCOME: {
      LABEL: "Incomes",
      DESCRIPTION: "Track and manage project income sources",
      BUTTON: {
        LABEL: "New Income",
        ICON: AddIcon,
      },
      ICON: TrendingUpIcon,
    },
    EXPENSES: {
      LABEL: "Expenses",
      DESCRIPTION: "Track and manage project expenses",
      BUTTON: {
        LABEL: "New Expense",
        ICON: AddIcon,
      },
      ICON: TrendingDownIcon,
    },
    MASTER_DATA: {
      LABEL: "Master Data",
      DESCRIPTION: "Manage master data for the project",
      BUTTON: {
        LABEL: "New Master Data",
        ICON: AddIcon,
      },
      ICON: SettingsIcon,
    },
    DOCUMENTS: {
      LABEL: "Documents",
      DESCRIPTION: "Project documents and file management",
      BUTTON: {
        LABEL: "Upload Document",
        ICON: AddIcon,
      },
      ICON: DescriptionIcon,
    },
    USERS: {
      LABEL: "Users",
      DESCRIPTION: "Project users and permissions",
      BUTTON: {
        LABEL: "Add User",
        ICON: AddIcon,
      },
      ICON: PersonIcon,
    },
    CONTACTS: {
      LABEL: "Contacts",
      DESCRIPTION: "Project contacts and communication",
      BUTTON: {
        LABEL: "New Contact",
        ICON: AddIcon,
      },
      ICON: PersonIcon,
    },
    PROJECT_NOTES: {
      LABEL: "Project Notes",
      DESCRIPTION: "Project-specific notes and documentation",
      BUTTON: {
        LABEL: "New Note",
        ICON: AddIcon,
      },
      ICON: NoteAddIcon,
    },
    ACTIVITY_LOG: {
      LABEL: "Activity Log",
      DESCRIPTION: "System-generated activity logs and project timeline",
      BUTTON: {
        LABEL: "Add Activity",
        ICON: AddIcon,
      },
      ICON: HistoryIcon,
    },
  },

  // Allocation Labels
  ALLOCATIONS: {
    VEHICLE: {
      TYPE: "VEHICLE",
      LABEL: "Vehicle",
      DESCRIPTION: "Allocate vehicles to the project",
      BUTTON: {
        LABEL: "New Vehicle Allocation",
        ICON: AddIcon,
      },
      ICON: VehicleIcon,
    },
    RESOURCE: {
      TYPE: "RESOURCE",
      LABEL: "WorkForce (Driver, etc.)",
      DESCRIPTION: "Allocate human resources to the project",
      BUTTON: {
        LABEL: "New WorkForce Allocation",
        ICON: AddIcon,
      },
      ICON: PersonIcon,
    },
    MASTER: {
      TYPE: "MASTER",
      LABEL: "Contract Master",
      DIVISIONLABEL: "Division Master",
      DESCRIPTION: "Allocate master data to the project",
      BUTTON: {
        LABEL: "New Master Data Allocation",
        ICON: AddIcon,
      },
      ICON: Storage,
    },
    ROUTE: {
      TYPE: "ROUTE",
      LABEL: "Route",
      DESCRIPTION: "Allocate routes to the project",
      BUTTON: {
        LABEL: "New Route Allocation",
        ICON: AddIcon,
      },
      ICON: Route,
    },
  },
};

export default GlobalLabels;
